import "./index.scss";

import React, { useEffect, useState } from "react";
import "react-phone-number-input/style.css";
import InputMessage from "../common/InputMessage";
import CustomButton from "../common/CustomButton";
import ServerError from "../common/ServerError";

const SignIn = ({ isShown, setIsSignInSubmitted, setSelectFilesOpened }) => {
  const [isServerError, setIsServerError] = useState(false);
  const [form, setForm] = useState({
    email: {
      value: "",
      error: "",
    },
    password: {
      value: "",
      error: "",
    },
  });

  useEffect(() => {
    setForm({
      email: {
        value: "",
        error: "",
      },
      password: {
        value: "",
        error: "",
      },
    });
  }, [isShown]);

  const validateInput = (name, value) => {
    setForm({ ...form, [name]: { value, error: "" } });
  };

  const submitForm = (event) => {
    event.preventDefault();

    const prepData = {
      email: form.email.value,
      password: form.password.value,
    };

    if (
      form.email.value === "test@gmail.com" &&
      form.password.value === "123456"
    ) {
      setSelectFilesOpened(true);
    }

    setForm({
      email: {
        value: "",
        error: "",
      },
      password: {
        value: "",
        error: "",
      },
    });

    // setIsServerError(false);
    // setIsSignInSubmitted(true);
  };

  return (
    <form
      onSubmit={submitForm}
      className={`black-form ${isShown && "black-form--show"}`}
    >
      <h1 className={`black-form__text black-form__title`}>get in touch</h1>
      <h2 className={`black-form__text black-form__subtitle`}>Contact Us</h2>
      <div className={`black-form__container`}>
        <div
          className={`black-form__group ${
            form.email.error && "black-form__group--error"
          }`}
        >
          <input
            type="email"
            name="email"
            className={`black-form__item black-form__input`}
            value={form.email.value}
            onChange={(e) => validateInput("email", e.target.value)}
            placeholder="Email"
          />
          <InputMessage isValue={form.email.value} error={form.email.error} placeholderText={"Email"} />
        </div>
        <div
          className={`black-form__group ${
            form.email.error && "black-form__group--error"
          }`}
        >
          <input
            type="password"
            name="password"
            className={`black-form__item black-form__input`}
            value={form.password.value}
            onChange={(e) => validateInput("password", e.target.value)}
            placeholder="Password"
          />
          <InputMessage isValue={form.password.value} error={form.password.error} placeholderText={"Password"} />
        </div>
        <CustomButton
          text={"sign in"}
          isSubmit={true}
          classNames={`black-form__button black-form__button--signIn`}
          isDisabled={
            form.password.value !== "123456" ||
            form.email.value !== "test@gmail.com"
          }
        />
        <ServerError isShown={isServerError} />
      </div>
    </form>
  );
};

export default SignIn;
